<template>
    <div class="container mx-auto mt-0 p-4 bg-gray-100 rounded-md shadow-lg w-full max-w-xs sm:max-w-sm">
    <div class="bg-gray-100 p-4 rounded-md">
      <h2 class="text-2xl md:text-xl font-semibold mb-4">Your Contact Details</h2>
      <form id="request-cash-offer" @submit.prevent="submitForm">
<div class="mb-4">
  <input
    class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline md:py-4 md:px-4 md:text-lg"
    id="firstName"
    type="text"
    v-model="firstName"
    placeholder="First Name"
    @blur="validateFirstName"
  />
  <p class="text-red-500 text-xs italic" v-if="firstNameError">{{ firstNameError }}</p>
</div>

<div class="mb-4">
  <input
    class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline md:py-4 md:px-4 md:text-lg"
    id="lastName"
    type="text"
    v-model="lastName"
    placeholder="Last Name"
    @blur="validateLastName"
  />
  <p class="text-red-500 text-xs italic" v-if="lastNameError">{{ lastNameError }}</p>
</div>


<div class="mb-4">
  <input
    class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline md:py-4 md:px-4 md:text-lg"
    id="email"
    type="text"
    v-model="email"
    placeholder="Email"
    @blur="validateEmail"
  />
  <p class="text-red-500 text-xs italic" v-if="emailError">{{ emailError }}</p>
</div>

<div class="mb-4">
  <input
    class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline md:py-4 md:px-4 md:text-lg"
    id="phone"
    type="text"
    v-model="phone"
    placeholder="Contact Number"
    @blur="validatePhone"
  />
  <p class="block text-xs font-medium text-gray-500 small-device-text pt-1">* We need a valid number to make an offer.</p>
  <p class="text-red-500 text-xs italic" v-if="phoneError">{{ phoneError }}</p>
</div>
      <div class="mb-4">
        <label class="inline-flex items-center">
          <input
            type="checkbox"
            class="form-checkbox text-green-500"
            v-model="privacyPolicy"
          />
          <span class="ml-2">I agree to the <a href="/privacy-policy" class="text-blue-500" target="_blank">Privacy Policy</a>.</span>
        </label>
        <p class="text-red-500 text-xs italic" v-if="privacyPolicyError">{{ privacyPolicyError }}</p>
      </div>


      <div class="mb-4">
  <div class="flex items-center justify-between">
    <button
      class="border-b-4 border-green-800 mt-2 text-lg block w-full items-center px-8 py-3 bg-green-600 text-white rounded-2xl font-bold hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
      type="submit">
      Submit→
    </button>
  </div>
  <!---<p class="mt-4 text-xs text-gray-500">
    By selecting 'Submit', you consent to being contacted by us via phone, SMS, email, and WhatsApp to discuss your property offer.
  </p>-->
</div>

      </form>
      <div class="mt-2 flex justify-center">
        <p class="text-gray-500 flex items-center">
          <i class="text-green-600 fas fa-shield-alt mr-1 text-sm items-center"></i>
          Safe, secure &amp; confidential
        </p>
      </div>
    </div>
  </div>
</template>

         
<script>
import axios from "axios";

const dataSoapApiKey = "3c6673da8ed24dadaffd5f7663631f5ed731304b6d24412a9c80384090af46c7"; 


export default {
  props: {
  addressData: {
    type: Object,
    default: () => ({}),
  },
  gclid: {
      type: String,
      default: '',
  },
  quizData: {
    type: Object,
    default: () => ({}),
  },
  lpOfferId: {
    type: String,
    default: '6' // Default value if not provided
  },
  lpCampaignId: {
    type: String,
    default: '5e2bf947eb5c7' // Default value if not provided
  },
  utmCampaign: {
    type: String,
    default: '',
  },
  utmSource: {
    type: String,
    default: '',
  },
  utmMedium: {
    type: String,
    default: '',
  },
  utmKeyword: {
    type: String,
    default: '',
  },
  utmMatch: {
    type: String,
    default: '',
  },
  utmDevice: {
    type: String,
    default: '',
  },
},
  name: "ContactForm",
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      firstNameError: "",
      lastNameError: "",
      emailError: "",
      phoneError: "",
      messageError: "",
      privacyPolicy: false,
      privacyPolicyError: "",
      isSubmitting: false,
      submitSuccess: false,
      submitError: false,
      quizDataMapping: {
      apiParam1: "homeowner",
      apiParam2: "prop_type",
      apiParam3: "beds",
      apiParam4: "reasons_for_sale",
      apiParam5: "speed_of_sale",
      apiParam6: "property_condition",
      apiParam7: "on_market",
      phoneHlrStatus: null,  // This will store the active status
      country: "", // New property for the country
    },
    localUtmCampaign: this.utmCampaign,
    localUtmSource: this.utmSource,
    localUtmMedium: this.utmMedium,
    localUtmKeyword: this.utmKeyword,
    localUtmDevice: this.utmDevice,
    localUtmMatch: this.utmMatch,
    localAdId: this.adId,
    localAdSetId: this.adSetId,
    localGclid: this.gclid,
    };
  },

    created() {
    if (this.localUtmCampaign) {
      localStorage.setItem("utm_campaign", this.localUtmCampaign);
    } else {
      const storedUtmCampaign = localStorage.getItem("utm_campaign");
      if (storedUtmCampaign) {
        this.localUtmCampaign = storedUtmCampaign;
      }
    }

    if (this.localGclid) {
      localStorage.setItem("gclid", this.localGclid);
    } else {
      const storedGclid = localStorage.getItem("gclid");
      if (storedGclid) {
        this.localGclid = storedGclid;
      }
    }

    if (this.localUtmSource) {
      localStorage.setItem("utm_source", this.localUtmSource);
    } else {
      const storedUtmSource = localStorage.getItem("utm_source");
      if (storedUtmSource) {
        this.localUtmSource = storedUtmSource;
      }
    }

    if (this.localUtmMedium) {
      localStorage.setItem("utm_medium", this.localUtmMedium);
    } else {
      const storedUtmMedium = localStorage.getItem("utm_medium");
      if (storedUtmMedium) {
        this.localUtmMedium = storedUtmMedium;
      }
    }

    if (this.localUtmKeyword) {
      localStorage.setItem("utm_keyword", this.localUtmKeyword);
    } else {
      const storedUtmKeyword = localStorage.getItem("utm_keyword");
      if (storedUtmKeyword) {
        this.localUtmKeyword = storedUtmKeyword;
      }
    }

    if (this.localUtmMatch) {
      localStorage.setItem("utm_matchtype", this.localUtmMatch);
    } else {
      const storedUtmMatch = localStorage.getItem("utm_matchtype");
      if (storedUtmMatch) {
        this.localUtmMatch = storedUtmMatch;
      }
    }

    if (this.localUtmDevice) {
      localStorage.setItem("utm_device", this.localUtmDevice);
    } else {
      const storedUtmDevice = localStorage.getItem("utm_device");
      if (storedUtmDevice) {
        this.localUtmDevice = storedUtmDevice;
      }
    }

  },




  methods: {
    validateFirstName() {
      if (!this.firstName) {
        this.firstNameError = "First name is required";
      } else {
        this.firstNameError = "";
      }
    },
    validateLastName() {
      if (!this.lastName) {
        this.lastNameError = "Last name is required";
      } else {
        this.lastNameError = "";
      }
    },

    validateEmail() {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!this.email) {
        this.emailError = "Email is required";
      } else if (!emailPattern.test(this.email)) {
        this.emailError = "Invalid email address";
      } else {
        this.emailError = "";
      }
    },


    async validatePhone() {
  const phonePattern = /^(\+?\d{1,4}[-\s]?)?(\d{1,4}[-\s]?){1,7}\d{1,4}$/;
  if (!this.phone) {
    this.phoneError = "Phone number is required";
  } else if (!phonePattern.test(this.phone)) {
    this.phoneError = "Invalid phone number";
  } else {
    try {
      const isValid = await this.validateMobileNumberWithDatasoap();
      if (isValid === false) {
        this.phoneError = "Invalid mobile number";
      } else {
        this.phoneError = ""; // <-- Set phoneError to an empty string
      }
    } catch (error) {
      console.error("Error validating mobile number with DataSoap:", error);
      // Fallback to original phone number validation
      this.phoneError = "";
    }
  }
},



    validatePrivacyPolicy() {
      if (!this.privacyPolicy) {
        this.privacyPolicyError = "You must agree to the Privacy Policy";
      } else {
        this.privacyPolicyError = "";
      }
    },


    async validateMobileNumberWithDatasoap() {
  try {
    const response = await axios.post(
      'https://api.datasoap.co.uk/v2',
      {
        lookup: this.phone,
        checks: ['hlr']
      },
      {
        headers: {
          'Content-Type': 'application/json-patch+json',
          'accept': 'text/plain',
          'Authorization': `Bearer ${dataSoapApiKey}`
        }
      }
    );
    console.log("DataSoap API response:", response.data);

    // Check if the phone number is syntactically valid
    if (response.data.valid === true) {
      // Check if the country is the UK using the alpha2Code field
      if (response.data.syntax.additional.country.alpha2Code === 'GB') {
        // Set the phoneHlrStatus based on the active status of the phone number
        this.phoneHlrStatus = response.data.hlr.on ? 'active' : 'non-active';

        // Clear any previous error messages as the number is valid and from the UK
        this.phoneError = "";

        // Return true if all conditions are satisfied
        return true;
      } else {
        // Set error message if the number is not from the UK
        this.phoneError = 'Only UK mobile numbers are allowed';
        return false;
      }
    } else {
      // Set error message if the phone number is not valid
      this.phoneError = 'Invalid mobile number';
      return false;
    }
  } catch (error) {
    console.error('Error validating mobile number with DataSoap:', error);

    // Fallback to original phone number validation using regex
    const phonePattern = /^(\+?\d{1,4}[-\s]?)?(\d{1,4}[-\s]?){1,7}\d{1,4}$/;
    if (!this.phone || !phonePattern.test(this.phone)) {
      this.phoneError = "Invalid phone number";
      return false;
    } else {
      // Clear the error if the fallback validation passes
      this.phoneError = "";
      return true;
    }
  }
},


    async submitForm() {
      this.validateFirstName();
      this.validateLastName();
      this.validateEmail();
      await this.validatePhone();
      this.validatePrivacyPolicy();

      if (this.firstNameError || this.lastNameError || this.emailError || (this.phoneError !== null && this.phoneError !== undefined && this.phoneError !== '') || this.privacyPolicyError) {
        return;
      }

      this.isSubmitting = true;

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      try {
        // Build JSON payload
        const payload = {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          phone: this.phone,
          site_ref: "rapidsale.co.uk",
          accepted_terms: this.privacyPolicy ? "1" : "0",
          lead_score: String(this.leadScore),
          // Address data
          address: this.addressData?.street || "",
          postcode: this.addressData?.postcode || "",
          country: this.addressData?.country || "",
          phone_hlr: this.phoneHlrStatus || "",
          // Quiz data mapped to API field names
          homeowner: this.quizData.apiParam1 || "",
          prop_type: this.quizData.apiParam2 || "",
          beds: this.quizData.apiParam3 || "",
          reasons_for_sale: this.quizData.apiParam4 || "",
          speed_of_sale: this.quizData.apiParam5 || "",
          property_condition: this.quizData.apiParam6 || "",
          on_market: this.quizData.apiParam7 || "",
          // UTM and tracking fields
          utm_source: this.localUtmSource || "",
          utm_medium: this.localUtmMedium || "",
          utm_campaign: this.localUtmCampaign || "",
          utm_term: "", // Not currently collected
          utm_content: "", // Not currently collected
          utm_keyword: this.localUtmKeyword || "",
          utm_device: this.localUtmDevice || "",
          utm_placement: "", // Not currently collected
          utm_matchtype: this.localUtmMatch || "",
          gclid: this.localGclid || "",
        };

        console.log('Submitting payload:', payload);

        await axios.post("https://app.leadseeker.co/api/affiliate-form/7_6_mkqx3tbmjtsktl", payload, config);

        this.submitSuccess = true;
        this.submitError = false;
      } catch (error) {
        this.submitSuccess = false;
        this.submitError = true;
        console.error("Error posting the form:", error);
      }

      this.isSubmitting = false;

      if (this.submitSuccess) {
      // At this point, we are sure that the lead score has been calculated,
      // and the form data has been successfully submitted.
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'leadSubmission',
        'lead_score': this.leadScore, // Make sure this is the correct and final value
        'email': this.email, // Make sure this.email contains the email value
      });

      // Redirect to the thank you page or display success message
      window.location.href = "/thank-you";
    } 
  },
},
computed: {
  isFormValid() {
    return (
      this.firstName &&
      this.lastName &&
      this.email &&
      this.phone &&
      this.privacyPolicy
      );
  },
  leadScore() {
    let score = 0;

    // Evaluate answers and assign scores based on your scoring system
    if (this.quizData.apiParam1 === 'Yes') {
      score += 10;
    }

    const propertyTypes = ['Detached', 'Semi-Detached', 'Bungalow'];
    if (propertyTypes.includes(this.quizData.apiParam2)) {
      score += 5;
    }

    const bedrooms = ['3', '4', '5+'];
    if (bedrooms.includes(this.quizData.apiParam3)) {
      score += 5;
    }

    const reasonsForSale = ['Stop Repossession', 'Stop Eviction', 'Mortgage Arrears', 'Financial', 'Other'];
    if (reasonsForSale.includes(this.quizData.apiParam4)) {
      score += 20;
    } else if (this.quizData.apiParam4 === 'Inherited' && this.quizData.apiParam5 === 'Within 7 Days') {
      score += 15;
    } else if (['Divorce', 'Ill Health'].includes(this.quizData.apiParam4)) {
      score += 10;
    } else if (this.quizData.apiParam4 === 'Financial Hardship') {
      score += 8;
    }

    if (['ASAP', 'Within 7 Days'].includes(this.quizData.apiParam5)) {
      score += 20;
    } else if (this.quizData.apiParam5 === '1-3 Weeks') {
      score += 10;
    }

    if (this.quizData.apiParam6 === 'Needs TLC') {
      score += 5;
    }

    return score;
  },
  
}
};
</script>

<style>
@media (max-width: 640px) {
  .small-device-text {
    font-size: 0.525rem; /* Adjust the value to your preference */
  }
}
</style>
